import { useQuery } from '@tanstack/react-query';
import GraphqlService from '../../../service/graphqlService';
import { calculateEndDateTimeIso, calculateStartDateTimeIso } from '../../../utils/dateUtils';

const useLifeCycleObjectPaginated = (
  key,
  project,
  id,
  queryParams,
  filters,
  startDate,
  endDate,
  startTime,
  endTime,
  page,
  pageSize,
) => {
  const query = useQuery(
    [key, project, id, queryParams, filters, startDate, endDate, startTime, endTime, page, pageSize],
    async () => {
      const response = await GraphqlService.getLifeCycleObjectPaginated(
        project.code,
        `${key}/${project.code}/${id}`,
        queryParams || '{}',
        filters || '{}',
        calculateStartDateTimeIso(startDate, startTime),
        calculateEndDateTimeIso(endDate, endTime),
        page,
        pageSize,
      );

      return {
        data: response ? JSON.parse(response.data) : [],
        pagination: response?.pagination,
      };
    },
    {
      enabled: !!project && !!id,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
    },
  );

  const { refetch } = query;
  return { ...query, refetch };
};

export default useLifeCycleObjectPaginated;
